export const environment = {
  appVersion: '2.73.3',
  production: true,
};
